import { IGuideApiModel } from './api';

export class GuideModel {
  id: number;
  creator: IGuideApiModel['creator'];
  title: string;
  subtitle: string;
  description: string;
  image: string;
  type: string;
  items: any;
  isPublished: boolean;
  placeNum: number;
  placeIds: Array<number>;
  structure: IGuideApiModel['structure'];
  slug: string;

  constructor(source?: IGuideApiModel) {
    if (source == null) {
      return;
    }

    this.id = source.id;
    this.creator = source.creator;
    this.title = source.title;
    this.subtitle = source.subtitle;
    this.description = source.description_page?.body ?? source.description;
    this.image = source.image_url;
    this.type = source.type;
    // this.items = source.items;
    this.isPublished = source.is_published;
    this.placeNum = source.beacon_num;
    this.placeIds = source.beacon_ids;
    this.structure = source.structure;
    this.slug = source.slug;
  }

  static copyObj(source: Pick<GuideModel, keyof GuideModel>): GuideModel {
    return Object.assign(new GuideModel(), source);
  }
}
